import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import { API } from "./../../config/api";
export default function MyOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  // Get user data from sessionStorage safely
  const user = JSON.parse(sessionStorage.getItem("user"));

  // 1. Memoized fetch function to prevent unnecessary re-renders
  const fetchOrders = useCallback(() => {
    if (user?.id) {
      fetch(`${API.LIST_USER_ORDERS}&user_id=${user.id}`)
        .then((res) => {
          if (!res.ok) throw new Error("Network response was not ok");
          return res.json();
        })
        .then((data) => {
          // Handle different possible JSON response structures
          if (Array.isArray(data)) {
            setOrders(data);
          } else if (data.orders && Array.isArray(data.orders)) {
            setOrders(data.orders);
          }
        })
        .catch((err) => console.error("Auto-fetch error:", err));
    }
  }, [user?.id]);

  // 2. Manage the Auto-Update Lifecycle
  useEffect(() => {
    // Initial fetch on component mount
    fetchOrders();

    // Set interval for refreshing data every 10 seconds
    const intervalId = setInterval(() => {
      fetchOrders();
    }, 10000);

    // CLEANUP: Important! Stops the timer when user leaves the page
    return () => clearInterval(intervalId);
  }, [fetchOrders]);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold">Order List</h3>
        {/* <div className="badge bg-light text-muted border px-3 py-2">
          <i className="bi bi-arrow-repeat me-1"></i> Auto-updating
        </div> */}
      </div>

      <div className="table-responsive bg-white shadow-sm rounded">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-primary">
            <tr>
              <th className="ps-3">Order No.</th>
              <th>Date</th>
              <th>Time</th>
              <th>Total_Amount</th>
              <th>Status</th>
              <th className="text-center pe-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {!user ? (
              <tr>
                <td colSpan="6" className="text-center py-5">
                  <div className="mb-2 fs-1">🔒</div>

                  <h5 className="fw-bold text-danger">Please login first</h5>

                  <p className="text-muted mb-3">
                    You need to login to view your orders
                  </p>

                  <button
                    className="btn btn-primary px-5 py-2 mt-2 fw-bold"
                    onClick={() => setShowLogin(true)}
                  >
                    Login Now
                  </button>

                  {/* Pop-up components */}
                  <Login
                    isOpen={showLogin}
                    onClose={() => setShowLogin(false)}
                    openRegister={() => {
                      setShowLogin(false);
                      setShowRegister(true);
                    }}
                  />
                  <Register
                    isOpen={showRegister}
                    onClose={() => setShowRegister(false)}
                    openLogin={() => {
                      setShowRegister(false);
                      setShowLogin(true);
                    }}
                  />
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order) => (
                <tr key={order.id}>
                  <td className="ps-3 fw-bold">{order.order_no}</td>
                  <td>{order.order_date}</td>
                  <td>{order.order_time}</td>

                  <td className="fw-bold">₹{order.total_amount}</td>

                  <td>
                    {order.status?.toLowerCase() === "confirmed" ? (
                      <span className="text-success fs-4">
                        <i className="bi bi-check-circle-fill"></i>
                      </span>
                    ) : order.status?.toLowerCase() === "cancelled" ? (
                      <span className="text-danger fs-4">
                        <i className="bi bi-x-circle-fill"></i>
                      </span>
                    ) : (
                      <span className="text-warning fs-4">
                        <i className="bi bi-clock-history"></i>
                      </span>
                    )}
                  </td>

                  <td className="text-center pe-3">
                    <button
                      className="btn btn-success btn-sm px-4 rounded-pill fw-bold"
                      onClick={() =>
                        navigate("/order-details", { state: order })
                      }
                    >
                      VIEW ORDER
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-5">
                  <div className="mb-2 fs-1">📦</div>

                  <h5 className="fw-bold text-dark">
                    You haven’t placed any orders yet
                  </h5>

                  <p className="text-muted mb-3">
                    Discover beautiful embroidery designs and place your first
                    order now
                  </p>

                  <button
                    className="btn btn-primary px-4 rounded-pill fw-bold"
                    onClick={() => navigate("/designes")}
                  >
                    Browse Free Designs
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
